<template>
    <svg
        fill="none"
        height="16"
        viewBox="0 0 15 16"
        width="15"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.8167 14.5332L10.5511 10.2676C11.3774 9.247 11.8749 7.95013 11.8749 6.53766C11.8749 3.26394 9.21114 0.600204 5.93742 0.600204C2.6637 0.600204 0 3.26391 0 6.53763C0 9.81134 2.66373 12.4751 5.93745 12.4751C7.34993 12.4751 8.6468 11.9776 9.66741 11.1513L13.933 15.4169C14.0549 15.5388 14.2149 15.6001 14.3749 15.6001C14.5349 15.6001 14.6949 15.5388 14.8168 15.4169C15.0611 15.1726 15.0611 14.7776 14.8167 14.5332ZM5.93745 11.2251C3.35247 11.2251 1.25 9.12261 1.25 6.53763C1.25 3.95264 3.35247 1.85017 5.93745 1.85017C8.52244 1.85017 10.6249 3.95264 10.6249 6.53763C10.6249 9.12261 8.52241 11.2251 5.93745 11.2251Z"
            fill="currentColor" />
    </svg>
</template>

<script setup lang="ts">
    const props = defineProps<{
        background?: string;
    }>();

    const background = computed(() => props.background || '#FFFFFF');
</script>

<style scoped></style>
